export default {
  route: {
    dashboard: 'Dashboard',
    profile: 'profile',
    icons: 'icons',

    system: 'System',
    setting: 'Setting',
    config: 'Config',
    menu: 'Menu',
    attachment: 'Attachment',

    permission: 'Permission',
    admin: 'Admin',
    adminIndex: 'AdminIndex',
    authGroup: 'AuthGroup',
    authGroupTree: 'AuthGroupTree',
    authRule: 'AuthRule',
    authRuleTree: 'AuthRuleTree',
    adminLog: 'AdminLog',

    localExtension: 'LocalExtension',
    extension: 'Extension',
    verification: 'Verification',
    verificationIndex: 'VerificationIndex'
  },
  navbar: {
    dashboard: 'Dashboard',
    github: 'Github',
    logOut: 'Log Out',
    profile: 'Profile',
    theme: 'Theme',
    size: 'Global Size'
  },
  login: {
    title: 'System Login',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    captcha: 'Captcha',
    refreshCaptcha: 'Refresh Captcha',
    refreshCaptchaTip: 'Go Refresh Captcha',

    'rules_username_required': 'pleace enter username',
    'rules_password_required': 'password must min 6 bytes',
    'rules_captcha_required': 'captcha must equal 4 bytes'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  },

  err401: {
    'title': '你没有权限去该页面',
    'content': '你可以进行以下操作解决你的问题',
    'relogin': '退出重新登录'
  },

  err404: {
    'content': 'Please check that the URL you entered is correct, or click the button below to return to the homepage.'
  },

  common: {
    'tips': 'Tips',
    'ok': 'Ok',
    'cancel': 'Cancel',
    'save': 'Save',

    'enable': 'Enable',
    'disable': 'Disable',

    'detail': 'Detail',
    'edit': 'Edit',
    'delete': 'Delete',

    'goto_top': 'GoTop',

    'clear_cache': 'Clear Cache',
    'clear_cache_success': 'Clear Cache Success',
    'confirm_clear_cache': 'You will clear Cache?',
    'clear_cache_doing': 'Clearing Cache...',

    'confirm_logout': 'Confirm logout?',

    'close_page': 'Close'
  }
}
